import { Control, UseFormSetValue, UseFormWatch } from "react-hook-form"
import { TSale } from "../../core/types/Sale"
import { TCheckoutLayout } from "../../core/types/Checkout"
import CheckoutClientDefault from "./Layouts/LayoutDefault/CheckoutClientDefault"
import CheckoutClient2 from "./Layouts/Layout2/CheckoutClient2"
import React from "react"
import CheckoutClient3 from "./Layouts/Layout3/CheckoutClient3"
import CheckoutClient4 from "./Layouts/Layout4/CheckoutClient4"
import CheckoutClient5 from "./Layouts/Layout5/CheckoutClient5"
import CheckoutClient6 from "./Layouts/Layout6/CheckoutClient6"
import CheckoutClient7 from "./Layouts/Layout7/CheckoutClient7"
import CheckoutClient8 from "./Layouts/Layout8/CheckoutClient8"

interface ICheckoutClient {
  layout?: TCheckoutLayout
  control: Control<TSale, any>
  setValue: UseFormSetValue<TSale>
  watch: UseFormWatch<TSale>
  saveLostSale: () => void
  clearErrors: () => void
}

const CheckoutClient = ({
  layout,
  control,
  setValue,
  watch,
  saveLostSale,
  clearErrors,
}: ICheckoutClient) => {
  if (!layout) return <></>

  const checkoutClientData = {
    [TCheckoutLayout.Default]: (
      <CheckoutClientDefault
        control={control}
        watch={watch}
        saveLostSale={saveLostSale}
        clearErrors={clearErrors}
      />
    ),
    [TCheckoutLayout.Layout2]: (
      <CheckoutClient2
        control={control}
        watch={watch}
        saveLostSale={saveLostSale}
        clearErrors={clearErrors}
      />
    ),
    [TCheckoutLayout.Layout3]: (
      <CheckoutClient3
        control={control}
        watch={watch}
        saveLostSale={saveLostSale}
        clearErrors={clearErrors}
      />
    ),
    [TCheckoutLayout.Layout4]: (
      <CheckoutClient4
        control={control}
        setValue={setValue}
        watch={watch}
        saveLostSale={saveLostSale}
        clearErrors={clearErrors}
      />
    ),
    [TCheckoutLayout.Layout5]: (
      <CheckoutClient5
        control={control}
        watch={watch}
        saveLostSale={saveLostSale}
        clearErrors={clearErrors}
      />
    ),
    [TCheckoutLayout.Layout6]: (
      <CheckoutClient6
        control={control}
        setValue={setValue}
        watch={watch}
        saveLostSale={saveLostSale}
        clearErrors={clearErrors}
      />
    ),
    [TCheckoutLayout.Layout7]: (
      <CheckoutClient7
        control={control}
        setValue={setValue}
        watch={watch}
        saveLostSale={saveLostSale}
        clearErrors={clearErrors}
      />
    ),
    [TCheckoutLayout.Layout8]: (
      <CheckoutClient8
        control={control}
        setValue={setValue}
        watch={watch}
        saveLostSale={saveLostSale}
        clearErrors={clearErrors}
      />
    ),
  }

  return checkoutClientData[layout] || <></>
}

export default CheckoutClient
